/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryView
 */
export interface CountryView {
    /**
     * 
     * @type {string}
     * @memberof CountryView
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CountryView
     */
    label: string;
}

/**
 * Check if a given object implements the CountryView interface.
 */
export function instanceOfCountryView(value: object): value is CountryView {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function CountryViewFromJSON(json: any): CountryView {
    return CountryViewFromJSONTyped(json, false);
}

export function CountryViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryView {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function CountryViewToJSON(value?: CountryView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
    };
}

